<template>
  <span>
    <b-modal @hidden="resetModal" ref="modal-container" v-model="modalShow" size="lg" static lazy hide-footer>
      <template #modal-title="">
        <i class="fas fa-plus"/>&nbsp;Add issue
      </template>
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <div v-for="({id, label, required, type, options = null, multiple = false}) in inputs" :key="id">
        <b-form-group :label="label" :label-for="`${id}-input`">
          <b-form-input v-if="type === 'string'"
                        :id="`${id}-input`"
                        v-model="formValues[id]" v-validate="{ required: required }"
                        :state="validateState(id)" :aria-describedby="`${id}-live-feedback`" :data-vv-name="id"
                        :data-vv-as="label" autocomplete="off"
          />
          <multiselect  v-if="type === 'multiselect'"
                        v-model="formValues[id]"
                        :options="options"
                        label="label"
                        :id="`${id}-input`"
                        :multiple="multiple"
                        :hide-selected="true"
                        track-by="value"
                        :placeholder="'Select ' + label"
          />
          <b-form-input v-if="type === 'number'"
                        type="number"
                        :id="`${id}-input`"
                        v-model="formValues[id]" v-validate="{ required: required }"
                        :state="validateState(id)" :aria-describedby="`${id}-live-feedback`" :data-vv-name="id"
                        :data-vv-as="label" autocomplete="off"
          />
          <b-form-select
              v-if="type === 'select'"
              :id="`${id}-input`"
              v-model="formValues[id]" v-validate="{ required: required }"
              :options="options"
              :state="validateState(id)" :aria-describedby="`${id}-live-feedback`" :data-vv-name="id"
              :data-vv-as="label" autocomplete="off"
          />
          <b-form-input v-if="type === 'datetime'"
                        hidden
                        :id="`${id}-input`"
                        v-model="formValues[id]" v-validate="{ required: required }"
                        :state="validateState(id)" :aria-describedby="`${id}-live-feedback`" :data-vv-name="id"
                        :data-vv-as="label" autocomplete="off"
          />
          <DatePicker
              v-if="type === 'datetime'"
              :id="`${id}-input`"
              input-class="form-control"
              type="datetime"
              v-model="formValues[id]"
              valueType="format"
              :placeholder="label"
              :shortcuts="dateShortcuts"
          />
          <b-form-invalid-feedback :id="`${id}-live-feedback`">{{ veeErrors.first(id) }}</b-form-invalid-feedback>
        </b-form-group>
        </div>
      </form>

      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit" :disabled="isLoading">Add</b-button>
    </b-modal>
  </span>
</template>

<style>
.is-invalid~.multiselect .multiselect__tags {
  border-color: red;
}
.is-invalid~.mx-datepicker input {
  border-color: red;
}
</style>

<script>
import Vue from "vue";
import {getRouteIcon, ROUTE_BGAMING_FREESPINS} from "../../utils/routerIcons";
import DatePicker from 'vue2-datepicker';
import {getFilterShortcuts} from "../../utils/dateUtils";
import Multiselect from "vue-multiselect";

export default {
  components: {
    DatePicker,
    Multiselect
  },
  data() {
    return {
      operatorOptions: [],
      gameOptions: [],
      modalShow: false,
      formValues: this.getInitialValues(),
      isLoading: false,
      dateShortcuts: getFilterShortcuts(),
      gameModules: [],
    }
  },
  props: {
    defaultValues: Object
  },
  methods: {
    getInitialValues() {
      return {
        operatorId: null,
        games: null,
        freespinsQuantity: null,
        betLevel: null,
        currency: null,
      };
    },
    validateState(ref) {
      if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    resetModal() {
      this.setDefaults();
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    showModal(data) {
      this.resetModal();

      if (data) {
        this.formValues = {
          games: data.games,
          freespinsQuantity: data.freespinsQuantity.toString(),
          betLevel: data.betLevel.toString(),
          currency: data.currency,
        }
        this.formValues.value = data.operatorId;
      }

      this.modalShow = true
    },
    handleSubmit() {
      this.inputs.forEach(({id, type}) => {
        if (id === 'module') {
          this.formValues[id] = this.formValues[id].id;
        } else {
          if (type === 'string' && this.formValues[id] !== null) {
            this.formValues[id] = this.formValues[id].trim();
          }
        }
      })
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        if (this.isLoading) {
          return;
        }

        this.isLoading = true;

        this
            .$http({
              url: '/api/v1/softswiss/freespins/add',
              method: 'POST',
              data: {
                ...this.formValues,
                operatorId: this.formValues.operatorId.value,
                games: this.formValues.games.map(game => game.value),
              },
              headers: {'Content-Type': 'application/json'},
            })
            .then(() => {
              this.hideModal();
              this.$toastr.i('Success');
              window.location.reload();
            })
            .catch((err) => {
              let message;

              if (typeof err.response.data.message === 'string') {
                message = err.response.data.message;
              } else {
                message = JSON.stringify(err.response.data.message);
              }

              this.$toastr.e(message);

              throw err;
            })
            .finally(() => {
              this.isLoading = false;
            });
      });
    },
    setDefaults() {
      let initialValues = this.getInitialValues();

      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field]);
      }

      if (this.defaultValues) {
        for (let field in this.defaultValues) {
          Vue.set(this.formValues, field, this.defaultValues[field]);
        }
      }
    },
  },
  computed: {
    routeIcon: () => getRouteIcon(ROUTE_BGAMING_FREESPINS),
    inputs() {
      return [
        {id: 'operatorId', label: 'Operator', required: true, type: 'multiselect', options: this.operatorOptions},
        {id: 'games', label: 'Game', required: true, type: 'multiselect', options: this.gameOptions, multiple: true},
        {id: 'freespinsQuantity', label: 'Freespins quantity', required: true, type: 'number'},
        {id: 'betLevel', label: 'Bet level', required: true, type: 'number'},
        {id: 'currency', label: 'Currency', required: true, type: 'string'},
        {id: 'userId', label: 'User Id', required: true, type: 'string'},
        {id: 'firstname', label: 'First name', required: true, type: 'string'},
        {id: 'lastname', label: 'Last name', required: true, type: 'string'},
        {id: 'city', label: 'City', required: true, type: 'string'},
        {id: 'validUntil', label: 'Valid until', required: true, type: 'datetime'},
      ]
    },
  },
  mounted() {
    this.setDefaults();
  },
  async beforeMount() {
    await this.$store.dispatch('operatorsForSelect/loadList').then(() => {
      this.operatorOptions = this.$store.getters['operatorsForSelect/list'].map(({label, value}) => {return { label, value }});
    });
    await this.$store.dispatch('softSwissGamesForSelect/loadList').then(() => {
      this.gameOptions = this.$store.getters['softSwissGamesForSelect/list'].map(({label, value}) => {return { label, value }});
    });
  },
}
</script>
